import { useEffect } from "react";
import { useSelector } from "react-redux";
import { syncExchangePairRoom } from "../services/exchangePairRoomSocket";

/**
 * Single place tied to Redux: pushes selected pair + user id into exchangePairRoomSocket so
 * joinRoom fires on pair change and on every reconnect with no duplicate emits from hooks.
 */
export function useExchangeRoomSync() {
  const selectedPair = useSelector((state) => state?.ats?.selectedPair);
  const userInfo = useSelector((state) => state?.persist?.userInfo);
  const userId = userInfo?.user_id;

  useEffect(() => {
    const payload =
      userId !== undefined && userId !== null
        ? { user_id: userId }
        : null;
    syncExchangePairRoom(selectedPair?.pair_key, payload);
  }, [selectedPair?.pair_key, userId]);
}
